import { c as _c } from "react/compiler-runtime";
import React from "react";
interface LabelProps {
  text: string;
}
const Label: React.FC<LabelProps> = t0 => {
  const $ = _c(2);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = <div className="lg:text-lg text-sm p-[2px] bg-gradient-to-r from-[#EDD821] to-[#AE9E17] rounded-full font-outfit font-normal"><div className="rounded-full bg-white px-3 bg-gradient-to-r from-[#FFF8DC] to-[#FFFFFF] text-[#5A5A5A]  py-[6px] ">{text}</div></div>;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Label;